import { AUTH_TUTOR, INITIALIZE } from 'actions'

/**
 * @type ReadingLevelState = ReadingLevel[]
 */
const initialState = []

const readingLevelReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_TUTOR:
        case INITIALIZE:
            return action.payload.readingLevels || []
        default:
            return state
    }
}

export default readingLevelReducer
